import React, { useEffect, useState} from 'react';
import { logoutConfirmation } from '../../pages/common/Utils';

export default function Header() {
    
    const [isToggled, setIsToggled] = useState(false);

    useEffect(() => {
        const toggled = localStorage.getItem('toggled');
        if (isToggled && toggled) {
          document.body.classList.add('ls-toggle-menu');
        } else {
          document.body.classList.remove('ls-toggle-menu');
        }
    }, [isToggled]);

    const handleHeaderToggle = (e) => {
        e.preventDefault();
        if (isToggled) {
            setIsToggled(false);
            localStorage.setItem('toggled', false);
        } else {
            setIsToggled(true);
            localStorage.setItem('toggled', true);
        }
    };
    return (
        <>
            <div className="page-loader-wrapper">
                <div className="loader">
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <p>Please wait...</p>
                    <div className="m-t-30">
                        <img src={ process.env.PUBLIC_URL + "/logo.png" } width={75} height={50} alt="Nexa" />
                    </div>
                </div>
            </div>
            <nav className="navbar">
                <div className="col-12">
                    <div className="navbar-header">
                        <a href="/authpanel/dashboard" className="bars" />
                        <a className="navbar-brand" href="/authpanel/dashboard">
                            <img src={ process.env.PUBLIC_URL + "/logo_black.png" } width={100} height={35} alt="Nexa" style={{ objectFit: 'cover' }} />
                        </a>
                    </div>
                    <ul className="nav navbar-nav navbar-left">
                        <li>
                            <a href={ "#" } className='ls-toggle-btn' data-close="true" id='headersidelock' onClick={handleHeaderToggle}>
                                <i className="zmdi zmdi-swap"></i>
                            </a>
                        </li>
                    </ul>
                    <ul className="nav navbar-nav navbar-right">
                        <li>
                            <a href="#" onClick={() => logoutConfirmation()} className="mega-menu" data-close="true">
                                <i className="zmdi zmdi-power" />
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
}